var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { StreakCompletionResult } from './user_streak';
export const MealType = {
    all: 'all',
    breakfast: 'breakfast',
    lunch: 'lunch',
    dinner: 'dinner',
    snacking: 'snacking',
};
export const MealLabel = {
    all: '全て',
    breakfast: '朝食',
    lunch: '昼食',
    dinner: '夕食',
    snacking: '間食',
};
export const MealDefaultTime = {
    breakfast: '07:00',
    lunch: '12:00',
    dinner: '19:00',
    snacking: '15:00',
};
export class MealMenu {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "menuId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "menuName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storeName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "imageUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "calorie", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "protein", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lipid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "carbohydrate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "availableCarbohydrate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "saltAmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "calcium", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "iron", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fiber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminA", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminB1", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminB2", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminB6", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminB12", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminC", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminD", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vitaminE", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "n3FattyAcid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "n6FattyAcid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "saturatedFat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cholesterol", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transFattyAcid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "kalium", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "magnesium", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "phosphorus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zinc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "copper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selenium", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "molybdenum", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "folate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alcohol", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.menuId = 'menuId' in data ? data.menuId : '';
        this.menuName = 'menuName' in data ? data.menuName : data.name;
        this.storeName = 'storeName' in data ? data.storeName : '';
        this.description = 'description' in data ? data.description : '';
        this.imageUrl = 'imageUrl' in data ? data.imageUrl : '';
        this.amount = data.amount || 1;
        this.calorie = data.calorie;
        this.protein = data.protein;
        this.lipid = data.lipid;
        this.carbohydrate = data.carbohydrate;
        this.availableCarbohydrate = data.availableCarbohydrate;
        this.saltAmount = data.saltAmount;
        this.calcium = data.calcium;
        this.iron = data.iron;
        this.fiber = data.fiber;
        this.vitaminA = data.vitaminA;
        this.vitaminB1 = data.vitaminB1;
        this.vitaminB2 = data.vitaminB2;
        this.vitaminB6 = data.vitaminB6;
        this.vitaminB12 = data.vitaminB12;
        this.vitaminC = data.vitaminC;
        this.vitaminD = data.vitaminD;
        this.vitaminE = data.vitaminE;
        this.n3FattyAcid = data.n3FattyAcid;
        this.n6FattyAcid = data.n6FattyAcid;
        this.saturatedFat = data.saturatedFat;
        this.cholesterol = data.cholesterol;
        this.transFattyAcid = data.transFattyAcid;
        this.kalium = data.kalium;
        this.magnesium = data.magnesium;
        this.phosphorus = data.phosphorus;
        this.zinc = data.zinc;
        this.copper = data.copper;
        this.selenium = data.selenium;
        this.molybdenum = data.molybdenum;
        this.folate = data.folate;
        this.alcohol = data.alcohol;
    }
    toJSON() {
        return {
            menu_id: this.menuId,
            menu_name: this.menuName,
            store_name: this.storeName,
            description: this.description,
            image_url: this.imageUrl,
            amount: this.amount,
            calorie: this.calorie,
            protein: this.protein,
            lipid: this.lipid,
            carbohydrate: this.carbohydrate,
            available_carbohydrate: this.availableCarbohydrate,
            salt_amount: this.saltAmount,
            calcium: this.calcium,
            iron: this.iron,
            fiber: this.fiber,
            vitamin_a: this.vitaminA,
            vitamin_b1: this.vitaminB1,
            vitamin_b2: this.vitaminB2,
            vitamin_b6: this.vitaminB6,
            vitamin_b12: this.vitaminB12,
            vitamin_c: this.vitaminC,
            vitamin_d: this.vitaminD,
            vitamin_e: this.vitaminE,
            n3_fatty_acid: this.n3FattyAcid,
            n6_fatty_acid: this.n6FattyAcid,
            saturated_fat: this.saturatedFat,
            cholesterol: this.cholesterol,
            trans_fatty_acid: this.transFattyAcid,
            kalium: this.kalium,
            magnesium: this.magnesium,
            phosphorus: this.phosphorus,
            zinc: this.zinc,
            copper: this.copper,
            selenium: this.selenium,
            molybdenum: this.molybdenum,
            folate: this.folate,
            alcohol: this.alcohol,
        };
    }
    toMealItemJSON() {
        const nutrients = this.toJSON();
        const name = nutrients.menu_name;
        Reflect.deleteProperty(nutrients, 'menu_id');
        Reflect.deleteProperty(nutrients, 'menu_name');
        Reflect.deleteProperty(nutrients, 'store_name');
        Reflect.deleteProperty(nutrients, 'description');
        Reflect.deleteProperty(nutrients, 'image_url');
        return Object.assign(Object.assign({}, nutrients), { name });
    }
    get menuKeyForConfirmPage() {
        var _a;
        return ((_a = this.id) === null || _a === void 0 ? void 0 : _a.toString()) || this.menuKey;
    }
    get menuKey() {
        return this.menuId || this.menuName;
    }
    get amountPercentage() {
        return this.amount * 100;
    }
    get nutrientSummary() {
        return [
            { key: 'protein', name: 'たんぱく質', value: this.protein },
            { key: 'lipid', name: '脂質', value: this.lipid },
            { key: 'carbohydrate', name: '炭水化物', value: this.carbohydrate },
            { key: 'saltAmount', name: '塩分', value: this.saltAmount },
        ];
    }
    caloriesForAmount(amountPercentage) {
        return Math.floor((this.calorie * amountPercentage) / 100);
    }
}
export class MealPreset {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalCalorie", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.totalCalorie = data.totalCalorie;
        this.items = data.items.map((item) => new MealMenu(item));
    }
}
export class MealImage {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "src", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.src = data.src;
        this.config = config;
    }
    get imageSrc() {
        return this.config.cdnUserBaseURL + '/' + this.src;
    }
    fileMap(i) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.imageSrc, { mode: 'cors', credentials: 'include' });
            const blob = yield response.blob();
            return { index: i, id: this.id, url: this.imageSrc, file: new File([blob], this.imageSrc, { type: 'image/jpg' }) };
        });
    }
}
export class MealCalorie {
    constructor(data) {
        Object.defineProperty(this, "date", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "calories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.date = data.date;
        this.calories = data.calories;
    }
}
export class UserMeal {
    constructor(data, config) {
        var _a;
        Object.defineProperty(this, "mealType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "eatenAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNotEating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userMealMenus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userMealImages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streakCompletionResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.mealType = data.mealType;
        this.eatenAt = new Date(data.eatenAt);
        this.isNotEating = data.isNotEating;
        const menus = 'items' in data ? data.items : data.userMealMenus;
        this.userMealMenus = (menus === null || menus === void 0 ? void 0 : menus.map((mealMenuData) => new MealMenu(mealMenuData))) || [];
        this.userMealImages = ((_a = data.userMealImages) === null || _a === void 0 ? void 0 : _a.map((mealImageData) => new MealImage(mealImageData, config))) || [];
        this.streakCompletionResult =
            'streakCompletionResult' in data &&
                data.streakCompletionResult &&
                new StreakCompletionResult(data.streakCompletionResult, config);
    }
    get sumCalories() {
        return this.userMealMenus.reduce((calories, v) => calories + v.caloriesForAmount(v.amountPercentage), 0);
    }
}
export class UserMealsForDay {
    constructor(data, config) {
        Object.defineProperty(this, "breakfast", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lunch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dinner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "snacking", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.breakfast = data.breakfast ? new UserMeal(data.breakfast, config) : null;
        this.lunch = data.lunch ? new UserMeal(data.lunch, config) : null;
        this.dinner = data.dinner ? new UserMeal(data.dinner, config) : null;
        this.snacking = data.snacking ? new UserMeal(data.snacking, config) : null;
    }
}
